import { Box, Grid, Skeleton } from '@mui/material';

import TableSkeleton from '@root/components/table/skeleton';
// import CloudProviderBarSkeleton from '@root/components/v2/content/CloudProviderBar/skeleton';
import ContentBox from '@root/components/v2/content/ContentBox';
import PageContent from '@root/components/v2/layout/PageContent';
import PageHeaderSkeleton from '@root/components/v2/layout/PageHeader/Skeleton';
import './style.scss';

const TitleTab = () => {
  return (
    <Box display={'flex'} gap={1} alignItems={'center'} mt={1}>
      <Skeleton className="rectangular" width={'150px'} height={'45px'} />

      <Skeleton className="rectangular" width={'150px'} height={'45px'} />
    </Box>
  );
};
/**
 * @param contentOnly render just the body, without the PageContent wrapper and header skeleton —
 * used as the fallback for a tab switch inside the Inventory shell, which owns the page chrome.
 */
function KeyInsightSkeleton({ contentOnly = false }: { contentOnly?: boolean }) {
  const body = (
    <>
        <TitleTab />
        <Box display={'flex'} flexDirection={'column'} gap={'15px'}>
          <Box display="flex" flexDirection="row" gap="15px" paddingTop={'15px'}>
            {['Risk', 'Triggers', 'Resource', 'Runtime Vulnerabilities'].map(title => (
              <ContentBox
                key={title}
                title={title}
                height={'396px'}
                paddingMode="content"
                headerEndElement={<Skeleton width="40px" />}
                style={{ flexGrow: 1, width: 'calc(25% - 15px)' }}>
                {/* Set a fixed width for each ContentBox */}

                <Box display="flex" flexDirection="column" alignItems="center" padding="15px" paddingTop="35px">
                  <Box width="100%" display="flex" justifyContent="center" marginBottom="5px">
                    {title === 'Top Service Categories' || title === 'Resource Trend' ? (
                      <Skeleton variant="rectangular" height="160px" sx={{ width: '100%', flexGrow: 1 }} />
                    ) : (
                      <Skeleton variant="circular" width="160px" height="160px" />
                    )}
                  </Box>
                  <Box flexGrow={0.4} height="10px" width="100%" />

                  <Box
                    width="100%"
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    marginBottom="10px">
                    <Skeleton width="100px" />
                    <Skeleton width="100px" />
                  </Box>
                  <Grid sx={{ width: '100%' }}>
                    {Array.from(new Array(title === 'Cloud Provider' ? 3 : 4)).map((i, index) => (
                      <Box
                        key={i}
                        width="100%"
                        display="flex"
                        flexDirection="column"
                        gap={title === 'Cloud Provider' ? '15px' : '10px'}>
                        <Box
                          display="flex"
                          flexDirection="row"
                          justifyContent="space-between"
                          marginTop={index === 0 ? '0px' : title === 'Cloud Provider' ? '20px' : '8px'}>
                          <Skeleton width="80px" />
                          {title === 'Resource Trend' && <Skeleton width="80px" />}
                          <Skeleton width="80px" />
                        </Box>
                      </Box>
                    ))}
                  </Grid>
                </Box>
              </ContentBox>
            ))}
          </Box>
          <Box display="flex" flexDirection="row" gap="15px">
            {['Evaluation', 'Runtimes', 'Exposed Secrets', 'Top 5 CVE'].map(title => (
              <ContentBox
                key={title}
                title={title}
                paddingMode="content"
                headerEndElement={<Skeleton width="40px" />}
                style={{ flexGrow: 1, width: 'calc(25% - 15px)' }}>
                {/* Set a fixed width for each ContentBox */}

                <Box display="flex" flexDirection="column" alignItems="center" padding="15px" paddingTop="35px">
                  <Box width="100%" display="flex" justifyContent="center" marginBottom="5px">
                    {title === 'Top Service Categories' || title === 'Resource Trend' ? (
                      <Skeleton variant="rectangular" height="160px" sx={{ width: '100%', flexGrow: 1 }} />
                    ) : (
                      <Skeleton variant="circular" width="160px" height="160px" />
                    )}
                  </Box>
                  <Box flexGrow={0.4} height="10px" width="100%" />

                  <Box
                    width="100%"
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    marginBottom="10px">
                    <Skeleton width="100px" />
                    <Skeleton width="100px" />
                  </Box>
                  <Grid sx={{ width: '100%' }}>
                    {Array.from(new Array(title === 'Cloud Provider' ? 3 : 4)).map((i, index) => (
                      <Box
                        key={i}
                        width="100%"
                        display="flex"
                        flexDirection="column"
                        gap={title === 'Cloud Provider' ? '15px' : '10px'}>
                        <Box
                          display="flex"
                          flexDirection="row"
                          justifyContent="space-between"
                          marginTop={index === 0 ? '0px' : title === 'Cloud Provider' ? '20px' : '8px'}>
                          <Skeleton width="80px" />
                          {title === 'Resource Trend' && <Skeleton width="80px" />}
                          <Skeleton width="80px" />
                        </Box>
                      </Box>
                    ))}
                  </Grid>
                </Box>
              </ContentBox>
            ))}
          </Box>
          <Box height={'63.7vh'}>
            <TableSkeleton ROWS_COUNT={9} COLUMNS_COUNT={9} />
          </Box>
        </Box>
    </>
  );

  if (contentOnly) return body;

  return (
    <PageContent className="PageContent__Skeleton_pt">
      <PageHeaderSkeleton />
      {/* <CloudProviderBarSkeleton marginBottom="5px" /> */}
      {body}
    </PageContent>
  );
}

export default KeyInsightSkeleton;
